import React from "react";
import ForumInput from "./ForumInputComponent";
import { IQuestion, QuestionType } from "src/network/fetchApplicationQuestions";
import OptionsQuestion from "./OptionsQuestion";
import MultipleSelectionQuestion from "./MultipleSelectionQuestion";
interface Props {
  question: IQuestion;
  index: number;
  shouldShowText: boolean;
  handleAnswerChange: (questionNumber: string, value: string) => void;
}

function ApplicationQuestionsHandler({
  question,
  shouldShowText,
  handleAnswerChange,
}: Props) {
  const { question_type } = question;

  // Map "boolean" answerType to "yesNo" for compatibility with the Question component
  // Render ForumInput for text and longtext
  if (question_type === QuestionType.Text && shouldShowText) {
    return (
      <ForumInput question={question} handleAnswerChange={handleAnswerChange} />
    );
  } else if (question_type === QuestionType.YesNo) {
    return (
      <OptionsQuestion
        question={question}
        handleAnswerChange={handleAnswerChange}
      />
    );
  } else if (question_type === QuestionType.Checkbox || question_type === QuestionType.Radio) {
    return (
      <MultipleSelectionQuestion
        question={question}
        handleAnswerChange={handleAnswerChange}
      />
    );
  }

  // Handle options and boolean types, passing them to Question component
  return null;
}
  
export default ApplicationQuestionsHandler;
